module.exports = __webpack_public_path__ + "img/main-visual.5b4a5c2b.png";